import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AgentState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AgentState = {
  data: [],
  isLoading: false,
  error: null,
};

const agentSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    setAgents: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAgentLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAgentError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setAgents, setAgentLoading, setAgentError } = agentSlice.actions;

export default agentSlice.reducer;
